import { Settings } from '@streamr/tv-engine';
import { EventEmitter } from 'eventemitter3';
import { createDoneEncodedAudioFrame, encodedAudioFrameToAudioFrame, } from '../streamrapp/types/EncodedAudioFrame';
import { createDoneEncodedVideoFrame } from '../streamrapp/types/EncodedVideoFrame';
import { MediaPacketFragmenter } from './MediaPacketFragmenter';
export class MediaPacketizer extends EventEmitter {
    mediaPacketFragmenter;
    audioFrameBuffer = [];
    mediaPacketCounter = 0;
    isVideoActive = false;
    constructor() {
        super();
        this.mediaPacketFragmenter = new MediaPacketFragmenter();
        this.audioFrameBuffer = [];
    }
    addVideoFrame(videoFrame, mediaStreamId) {
        const mediaPacket = {
            packetNumber: BigInt(this.mediaPacketCounter++),
            videoFrames: [videoFrame],
            audioFrames: this.audioFrameBuffer,
            mediaStreamId,
            endedTracks: [],
        };
        this.audioFrameBuffer = [];
        const fragments = this.mediaPacketFragmenter.fragmentMediaPacket(mediaPacket);
        for (const fragment of fragments) {
            this.emit('mediaPacketFragment', fragment);
        }
    }
    addAudioFrames(audioFrames, mediaStreamId) {
        if (!this.isVideoActive) {
            const mediaPacket = {
                packetNumber: BigInt(this.mediaPacketCounter++),
                audioCodec: Settings.audioCodec,
                videoFrames: [],
                audioFrames: audioFrames,
                mediaStreamId,
                endedTracks: [],
            };
            const fragments = this.mediaPacketFragmenter.fragmentMediaPacket(mediaPacket);
            for (const fragment of fragments) {
                this.emit('mediaPacketFragment', fragment);
            }
        }
        else {
            this.audioFrameBuffer.push(...audioFrames);
        }
    }
    setIsVideoActive(isVideoActive) {
        console.log('setIsVideoActive', isVideoActive);
        this.isVideoActive = isVideoActive;
    }
    sendDoneVideoFrame(trackId, frameNumber, mediaStreamId) {
        this.addVideoFrame(createDoneEncodedVideoFrame(trackId, frameNumber), mediaStreamId);
        this.flush(mediaStreamId);
    }
    sendDoneAudioFrame(trackId, frameNumber, mediaStreamId) {
        const doneFrame = createDoneEncodedAudioFrame(trackId, frameNumber);
        this.addAudioFrames([encodedAudioFrameToAudioFrame(doneFrame)], mediaStreamId);
        this.flush(mediaStreamId);
    }
    flush(mediaStreamId) {
        const mediaPacket = {
            packetNumber: BigInt(this.mediaPacketCounter++),
            audioCodec: Settings.audioCodec,
            videoFrames: [],
            audioFrames: this.audioFrameBuffer,
            mediaStreamId,
            endedTracks: [],
        };
        this.audioFrameBuffer = [];
        const fragments = this.mediaPacketFragmenter.fragmentMediaPacket(mediaPacket);
        for (const fragment of fragments) {
            this.emit('mediaPacketFragment', fragment);
        }
        console.log('Flushed buffered audio frames');
    }
}
